import { createAction, props } from '@ngrx/store';
import { ServerInfoResponse } from '@nx-customer-apps/api-planning-projects';

export namespace FooterActions {
    export const getApiInfo = createAction('[FOOTER] Get Api Info');
    export const getApiInfoSuccess = createAction('[FOOTER] Get Api Info Success', props<ServerInfoResponse>());
}
